// extracted by mini-css-extract-plugin
module.exports = {"AppCreate":"App_AppCreate__3Nl-J"};